module.exports = __webpack_public_path__ + "img/icon-filter.04ba0693.png";